var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade" } }, [
    _vm.loading
      ? _c("div", { key: 1, staticClass: "loading-overlay" }, [_c("loader")], 1)
      : _c("div", { staticClass: "quiz" }, [
          _c("section", { staticClass: "content" }, [_vm._t("content")], 2),
          _vm._v(" "),
          _c("section", { staticClass: "cta-container" }, [
            _c(
              "div",
              { staticClass: "quiz-buttons" },
              [_vm._t("cta-buttons")],
              2
            ),
            _vm._v(" "),
            !_vm.hideExit
              ? _c(
                  "div",
                  { staticClass: "button transparent quiz-footer-buttons" },
                  [
                    _c("button", {
                      staticClass: "button transparent quiz-back-button",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.$router.go(-1)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "button transparent quiz-exit-button",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.$router.push({ path: "/" })
                          }
                        }
                      },
                      [_vm._v("Exit")]
                    ),
                    _vm._v(" "),
                    _vm._t("exit-button-left")
                  ],
                  2
                )
              : _vm._e()
          ])
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-45bae7f5", { render: render, staticRenderFns: staticRenderFns })
  }
}